	export enum ReportTypeEnum {
		Common = 1,
		SSRS = 2
	}
